module.exports = __webpack_public_path__ + "img/process_img03.4c3a43b1.png";